export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7988.e9d882fb.jpg";